// src/Pages/Usuario/Agenda/components/SlotBtn.jsx
import React from "react";

/**
 * Botón de horario reutilizable
 */

const SlotBtn = ({
  ymd,
  hhmm,
  primarySlot,
  onPickPrimary,
  info,
  isBreak,
  reglaServicio,
  effectiveBreaks,
  ocupacionBloques,
}) => {

// ============================
// INFO REAL DEL BLOQUE (SIEMPRE desde ocupacionBloques)
// ============================
const infoReal = ocupacionBloques?.get(hhmm) || info || {};

const {
  total = 0,
  topables = 0,
  exclusiva = false,
  postBuffer = false,
  postDePrivada = false,   // 👈
  postDeGrupal = false,    // 👈
  bufferPrevio = false,
  esBloqueReal = false,
  grupales = 0,
  privadas = 0,
} = infoReal;



// ============================
// HELPERS DE TIEMPO (DEBEN IR ANTES)
// ============================
const HHmmToDate = (ymd, hhmm) => {
  const [h, m] = hhmm.split(":").map(Number);
  const d = new Date(`${ymd}T00:00`);
  d.setHours(h, m, 0, 0);
  return d;
};

const addMinutes = (d, min) => new Date(d.getTime() + min * 60000);

const toHHmm = (d) =>
  `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;

const minus30 = (hhmm) => {
  const [h, m] = hhmm.split(":").map(Number);
  const d = new Date();
  d.setHours(h, m - 30, 0, 0);
  return toHHmm(d);
};


// ============================
// REGLA DEL SERVICIO QUE QUIERES AGENDAR (NO de la reserva existente)
// ============================
const permiteTopar = reglaServicio?.permiteTopar === true;
const capacidadMax = reglaServicio?.capacidadMax ?? 1;

const dur = reglaServicio?.duracionMin ?? 60;
const previo = reglaServicio?.bloqueaPrevio ?? 0;
const post = reglaServicio?.bloqueaPosterior ?? 0;

// “exclusiva” para la NUEVA reserva:
const nuevaReservaEsExclusiva = !permiteTopar;

// En la función colisionaConOcupacion() de SlotBtn.jsx, modificar:

const colisionaConOcupacion = () => {
  if (!ocupacionBloques) return false;

  const inicio = HHmmToDate(ymd, hhmm);
  const finReal = addMinutes(inicio, dur);

  const esNuevaGrupal = permiteTopar === true;

  let cursor = new Date(inicio);

  while (cursor < finReal) {
    const key = toHHmm(cursor);
    const infoB = ocupacionBloques.get(key);

    if (infoB) {
        if (esNuevaGrupal) {

          // grupal NO puede topar privadas reales

          if (
            infoB.esBloqueReal &&
            (infoB.privadas ?? 0) > 0
          ) {

            return true;

          }

          if (!infoB.esBloqueReal) {
              cursor = addMinutes(cursor,30);
              continue;
            }

          const ocupacionReal =
          (infoB.grupales ?? 0);

          const capacidad =
          infoB.capacidadMax ?? 2;

          // solo bloquea si el bloque REAL llegó al máximo
          if (
          infoB.esBloqueReal &&
          ocupacionReal >= capacidad
          ) {
          return true;
          }

        } else {
        // ✅ Nueva PRIVADA:
        // 1) SOLO bloquea si pisa BLOQUE REAL (privada o grupal)
        const ocupaRealmente =

            infoB.esBloqueReal &&

            (

            infoB.inicioPrivada ||

            infoB.inicioGrupal ||

            infoB.inicioReserva

            );

            if (
            ocupaRealmente &&
            (infoB.total ?? 0) > 0
            ) {
            return true;
            }



        // 3) Si es SOLO prebuffer de privada (total>0 pero NO esBloqueReal), se permite
      }
    }

    cursor = addMinutes(cursor, 30);
  }

  return false;
};


  // ============================
  // REGLAS DINÁMICAS
  // ============================
  const duracion = reglaServicio?.duracionMin ?? 60;
  
  const hhmmToMinutes = (hhmm) => {
    const [h, m] = hhmm.split(":").map(Number);
    return h * 60 + m;
  };

    const getNextSlot = (hhmm) => {
    const [h, m] = hhmm.split(":").map(Number);
    const d = new Date();
    d.setHours(h, m + 30, 0, 0);
    return toHHmm(d);
  };

  const getBloquesOcupados = (ymd, hhmm, duracionMin) => {
    const inicio = HHmmToDate(ymd, hhmm);
    const bloques = [];
    let cursor = new Date(inicio);
    let restante = duracionMin;

    // incluimos TODOS los cortes cada 30 min, incluido el del final
    while (restante > 0) {
      bloques.push(toHHmm(cursor));
      cursor = addMinutes(cursor, 30);
      restante -= 30;
    }

    return bloques;
  };

const bloquesServicio = getBloquesOcupados(ymd, hhmm, duracion);

// ============================
// BREAKS EFECTIVOS (ANTES DE USARSE)
// ============================
const bloqueEnBreak = bloquesServicio.some((b) =>
  effectiveBreaks?.some((br) => b >= br.start && b < br.end)
);

if (bloqueEnBreak) {
console.log(
"BREAK:",
hhmm,
bloquesServicio,
effectiveBreaks
);
}
  // ============================
  // BLOQUEO POR BUFFER PREVIO
  // ============================

// ============================
// BLOQUEO POR BUFFER PREVIO (CORRECTO POR RANGO)
// - Solo aplica a reservas exclusivas (privadas)
// - NO aplica a grupales (permiteTopar)
// - Considera la DURACIÓN real del slot (8:30→9:30 NO toca buffer de 10:00)
// ============================

// Buffer previo en minutos (por defecto 30)
const bufferPrevioMin =
reglaServicio?.bloqueaPrevio ?? 30;

const nuevaReservaUsaBufferPrevio = true;

const bloqueadoPorBufferPrevio =
  nuevaReservaUsaBufferPrevio &&
  Array.from(ocupacionBloques?.entries() || []).some(
    ([horaInicio, infoBloque]) => {

      if (!infoBloque) return false;

      // SOLO bloques reales
      if (!infoBloque.esBloqueReal) return false;

      const esPrivadaReal =
        (infoBloque.privadas ?? 0) > 0;

      const esGrupalReal =
        (infoBloque.grupales ?? 0) > 0;

      // PRIVADA nueva:
      // buffer previo SOLO respecto a grupales reales
      if (
        nuevaReservaEsExclusiva &&
        !esGrupalReal
      ) {
        return false;
      }

      // GRUPAL nueva:
      // buffer previo SOLO respecto a privadas reales
      if (
        !nuevaReservaEsExclusiva &&
        !esPrivadaReal
      ) {
        return false;
      }

      const inicioExistente =
        hhmmToMinutes(horaInicio);

      const inicioCandidato =
        hhmmToMinutes(hhmm);

      const bufferInicio =
        inicioExistente - bufferPrevioMin;

      return (
        inicioCandidato >= bufferInicio &&
        inicioCandidato < inicioExistente
      );
    }
  );

const isReserved = false;

const disabled =

  isBreak ||

  bloqueEnBreak ||

  bloqueadoPorBufferPrevio ||

  (

    nuevaReservaEsExclusiva &&

    (

    infoReal.exclusiva ||

    infoReal.bufferPrevio ||

    infoReal.postDePrivada ||

    (
    infoReal.esBloqueReal &&
    (infoReal.total ?? 0) > 0
    )

    )

  ) ||

  (

    !nuevaReservaEsExclusiva &&

    (

      infoReal.exclusiva ||

      infoReal.bufferPrevio ||

      //infoReal.postDePrivada ||

      infoReal.postDeGrupal ||   // ← AGREGAR

      infoReal.postBuffer ||

      infoReal.inicioPrivada ||

      (
        infoReal.esBloqueReal &&
        (infoReal.topables ?? 0) >=
        (infoReal.capacidadMax ?? 2)
      )

    )

  );

const capacidadBloque =
infoReal.capacidadMax ?? 2;

 // const hasOcupacion = total > 0;

let badge = null;

const hayPrivadaReal =
esBloqueReal &&
(privadas ?? 0) > 0;

const hayGrupalReal =
esBloqueReal &&
(grupales ?? 0) > 0;

// NUEVO:

const grupalDebeVerseReservada =
nuevaReservaEsExclusiva &&
hayGrupalReal;

if (hhmm === "18:30") {
  console.log("18:30 infoReal completo →", JSON.stringify(infoReal));
  console.log("18:30 disabled →", disabled);
  console.log("18:30 nuevaReservaEsExclusiva →", nuevaReservaEsExclusiva);
}

// EXISTE PRIVADA → SIEMPRE reservado

if (hayPrivadaReal) {

  badge = (

    <span className="text-[10px] px-2 py-[1px] rounded-full bg-rose-100 border border-rose-200 text-rose-700">

      reservado

    </span>

  );

}

// EXISTE SOLO GRUPAL → mostrar cupos

else if (
hayGrupalReal &&
!grupalDebeVerseReservada
) {

  badge = (

    <span className="text-[10px] px-2 py-[1px] rounded-full bg-yellow-300 text-yellow-900">

      {grupales}/{capacidadBloque}

    </span>

  );

}

if (grupalDebeVerseReservada) {

badge = (

<span className="text-[10px] px-2 py-[1px] rounded-full bg-rose-100 border border-rose-200 text-rose-700">

reservado

</span>

);

}


  // ============================
  // CLASES DEL BOTÓN
  // ============================
  const isSelected =
    primarySlot?.fecha === ymd && primarySlot?.hora === hhmm;

const nextOfSelected =
  primarySlot?.fecha === ymd &&
  primarySlot?.hora &&
  hhmmToMinutes(hhmm) >
    hhmmToMinutes(primarySlot.hora) &&
  hhmmToMinutes(hhmm) <
    hhmmToMinutes(primarySlot.hora) +
      (reglaServicio?.duracionMin ?? 60);

// ============================
// CLASES DEL BOTÓN (UX FINAL)
// ============================

let classes =
  "relative p-3 rounded-xl border text-sm font-semibold transition flex flex-col items-center";

// seleccionado visual (slot elegido + bloques siguientes)
if (isSelected || nextOfSelected) {

  classes +=
    " bg-[#00698f] text-white border-[#00698f]";

}

// deshabilitados
else if (

  disabled ||

  bloqueadoPorBufferPrevio

) {

  classes +=
    " bg-gray-100 border-gray-300 text-gray-400 cursor-not-allowed";

}

// normal
else {

  classes +=
    " bg-white border-gray-300 hover:bg-blue-50 hover:border-blue-400 text-[#0E1A36] cursor-pointer";

}
  // ============================
  // RENDER FINAL
  // ============================
return (
    <button
      type="button"
      // 🔴 IMPORTANTE: Agregar bloqueadoPorBufferPrevio al disabled
disabled={disabled}
onClick={
disabled
? undefined
: () => onPickPrimary(ymd, hhmm)
}


      className={classes}
    >
      <div className="flex items-center gap-2">
        <span className="font-medium">{hhmm}</span>
        {badge}
      </div>
    </button>
  );
};

export default SlotBtn;
